export type RecommendationState = 'matched' | 'default' | 'unsupported'

// Digioh sends a display label, never a Shopify handle, variant ID or destination.
export function recommendationState(params: URLSearchParams, parameter: string, label: string): RecommendationState {
	if (!parameter.trim() || !label.trim()) return 'unsupported'
	const values = params.getAll(parameter.trim())
	if (values.length === 0 || (values.length === 1 && !values[0].trim())) return 'default'
	if (values.length !== 1) return 'unsupported'
	return values[0].trim().toLowerCase() === label.trim().toLowerCase() ? 'matched' : 'unsupported'
}

export type RecommendationConfiguration = { parameter: string; label: string; product: string; defaultBundle?: boolean }

// A URL may select one merchant-authored section, never resolve a product handle.
export function selectRecommendation(params: URLSearchParams, configurations: RecommendationConfiguration[]): { index: number | null; state: RecommendationState } {
	const unsupported = { index: null, state: 'unsupported' as const }
	const parameter = configurations[0]?.parameter.trim()
	if (!parameter || configurations.some(config => config.parameter.trim() !== parameter || !config.label.trim() || !config.product.trim())) return unsupported
	const defaults = configurations.flatMap((config, index) => config.defaultBundle === true ? [index] : [])
	// Conflicting defaults and repeated inputs must never turn into a purchase choice.
	if (defaults.length > 1 || params.getAll(parameter).length > 1) return unsupported
	const states = configurations.map(config => recommendationState(params, parameter, config.label))
	const matches = states.flatMap((state, index) => state === 'matched' ? [index] : [])
	if (matches.length === 1) return { index: matches[0], state: 'matched' }
	if (matches.length > 1) return unsupported
	// Missing, blank or unknown labels may use the single merchant-selected default.
	// The distinct state keeps this ordinary product fallback nonpersonalized.
	if (defaults.length === 1) return { index: defaults[0], state: 'default' }
	// Preserve the direct-visit fallback only when there is no choice to guess.
	if (configurations.length === 1 && states[0] === 'default') return { index: 0, state: 'default' }
	return unsupported
}
